import modules from 'src/store/modules/index.js'

export const startStoreAutoInitDispatcher = async (store, isAfterInit = false) => {
  const actionName = isAfterInit ? 'afterInit' : 'init'
  for (const moduleName of Object.keys(modules)) {
    if (modules[moduleName].actions && modules[moduleName].actions[actionName]) {
      await store.dispatch(`${moduleName}/${actionName}`)
    }
  }
}

export const startStoreAutoAfterInitDispatcher = (store) => {
  // No need await this, since after init actions are not critical for the app start.
  // They are used to load data such as notification count, etc.
  startStoreAutoInitDispatcher(store, true)
}

export const resetStoreAutoDispatcher = async (store) => {
  // Reset Vuex-ORM entities
  await store.dispatch('entities/deleteAll')

  // Reset module states
  const mutationName = 'RESET_STATE'
  for (const moduleName of Object.keys(modules)) {
    if (modules[moduleName].mutations && modules[moduleName].mutations[mutationName]) {
      await store.commit(`${moduleName}/${mutationName}`)
    }
  }

  // Reset root state
  await store.commit(mutationName)
}
